import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const CarouselSectionSquareImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '1_1_568', width: 540, height: 540, ratio: 1 },
];
